export const PostLoading = ({ loading }: { loading: boolean }) => {
    return (
        <>
            {true ? (
                <div className="card card-post" style={{ overflow: "hidden", opacity: loading ? 1 : 0 }}>
                    <div className="row row-post" style={{ flexWrap: "nowrap", overflow: "hidden" }}>
                        <div className="row">
                            <div className="col-2 col-img-account-post img-list-chat img-account-search" style={{cursor: "pointer"}}>
                                <span className="placeholder user-select-none img-account-post" style={{width: "100%", height: "100%"}}/>
                            </div>

                            <div className="col col-post"style={{ cursor: "pointer" }}>
                                <h2 onClick={(e) => e.stopPropagation()} className="cursor-pointer">
                                    <a className="link-name placeholder-text" style={{width: "90%"}} href={"#"}>
                                        <span className="placeholder placeholder-text" style={{width: "90%", height: "20px"}}></span>
                                    </a>
                                </h2>

                                <p className="seguidor-post cursor-pointer">
                                    <span className="placeholder" style={{width: "50px", height: "10px", marginTop: "-3px" }}></span>
                                </p>
                            </div>
                        </div>

                        <div className="col-1 col-conf-post">
                            <div className="dropdown">
                                <button
                                    aria-label="Configuração do POST"
                                    style={{ border: 0, borderRadius: "5px", background: "var(--background-post)" }}
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <span className="placeholder" style={{width: "20px", height: "20px"}}></span>
                                </button>
                            
                            </div>
                        </div>
                    </div>

                    <div style={{ overflow: "hidden" }} className={`row row-text-post`}>
                        <p className="text-post-placeholder placeholder" style={{marginTop: "10px", marginBottom: "2px!important", width: "90%"}}/>
                        <p className="text-post-placeholder placeholder" style={{marginTop: "-5px", marginBottom: "2px!important", width: "60%"}}/>
                    </div>
                </div>
            ): null}
        </>
    );
}